import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pl } from "date-fns/locale"; // Import Polish locale

const AddRecord = () => {
  const [panels, setPanels] = useState([
    {
      przyrzad_pomiarowy: "",
      miejsce_uzytkowania: "",
      okres_waznosci_legalizacji: "",
      data_waznosci: new Date(),
      data_wystawienia: "",
      emails: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const fileInputRef = useRef(null);

  const handleInputChange = (index, field, value) => {
    const updatedPanels = [...panels];
    updatedPanels[index][field] = value;
    setPanels(updatedPanels);
  };

  const addPanel = (data = {}) => {
    setPanels((prevPanels) => [
      ...prevPanels,
      { ...data, data_waznosci: new Date() },
    ]);
  };

  const removePanel = (index) => {
    if (panels.length > 1) {
      setPanels(panels.filter((_, i) => i !== index));
    } else {
      setMessage({ type: "error", text: "Musi być conajmniej jeden panel." });
      setTimeout(() => setMessage({ type: "", text: "" }), 5000);
    }
  };

  const handleFileUpload = async (file) => {
    if (!file || !["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setMessage({ type: "error", text: "Nieprawidłowy format pliku." });
      setTimeout(() => setMessage({ type: "", text: "" }), 5000);
      return;
    }

    setLoading(true);
    setMessage({ type: "", text: "" });

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("https://api.wiczka.eu/api/upload/", {
        method: "POST",
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
        body: formData,
      });

      if (response.ok) {
        const jsonData = await response.json();
        Object.keys(jsonData).forEach((key) => addPanel(jsonData[key]));
        setMessage({ type: "success", text: "Plik przetworzony pomyślnie!" });
      } else {
        setMessage({ type: "error", text: "Błąd podczas przetwarzania pliku." });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Błąd połączenia z serwerem." });
    }

    setTimeout(() => setMessage({ type: "", text: "" }), 5000);
    setLoading(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files.length > 0) {
      handleFileUpload(event.dataTransfer.files[0]);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage({ type: "", text: "" });

    const token = localStorage.getItem("token");

    const payload = panels.map((panel) => ({
      data_waznosci: panel.data_waznosci.toISOString().split("T")[0],
      przyrzad_pomiarowy: panel.przyrzad_pomiarowy,
      okres_waznosci_legalizacji: panel.okres_waznosci_legalizacji,
      miejsce_uzytkowania: panel.miejsce_uzytkowania,
      data_wystawienia: panel.data_wystawienia,
      emails: panel.emails,
    }));

    try {
      const response = await fetch("https://api.wiczka.eu/api/data/post/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setMessage({ type: "success", text: "Dane wysłane pomyślnie!" });
        setTimeout(() => {
          document.getElementById("resetHiddenButton").click();
        }, 1000);
      } else {
        setMessage({ type: "error", text: "Wystąpił błąd podczas wysyłania danych." });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Nie udało się połączyć z serwerem." });
    }

    setTimeout(() => setMessage({ type: "", text: "" }), 5000);
    setLoading(false);
  };

  const resetForm = () => {
    setPanels([{ id: 1, content: "" }]); // Reset to 1 empty panel
    setPanels([
      {
        przyrzad_pomiarowy: "",
        miejsce_uzytkowania: "",
        okres_waznosci_legalizacji: "",
        data_waznosci: new Date(),
        data_wystawienia: "",
        emails: "",
      },
    ]);
  
    // Clear file input if ref is available
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input
    }
  };
  
  

  return (
    <div className={`form-container ${loading ? "loading-overlay" : ""}`} onDragOver={(e) => e.preventDefault()} onDrop={handleDrop}>
      <div className="file-upload" onClick={() => fileInputRef.current.click()}>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={(e) => handleFileUpload(e.target.files[0])}
        />
        <p>Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać</p>
      </div>

      {loading && <div className="loading-circle"></div>}

      {panels.map((panel, index) => (
        <div key={index} className="panel">
          <label>Przyrząd pomiarowy</label>
          <input type="text" placeholder="Przyrząd pomiarowy" value={panel.przyrzad_pomiarowy} onChange={(e) => handleInputChange(index, "przyrzad_pomiarowy", e.target.value)} />
          <label>Miejsce użytkowania</label>
          <input type="text" placeholder="Miejsce użytkowania" value={panel.miejsce_uzytkowania} onChange={(e) => handleInputChange(index, "miejsce_uzytkowania", e.target.value)} />
          <label>Okres ważności legalizacji (zczytane)</label>
          <input type="text" placeholder="Okres ważności legalizacji" value={panel.okres_waznosci_legalizacji} onChange={(e) => handleInputChange(index, "okres_waznosci_legalizacji", e.target.value)} />
          <label>Data ważności legalizacji</label>
          <DatePicker selected={panel.data_waznosci} onChange={(date) => handleInputChange(index, "data_waznosci", date)} locale={pl} dateFormat="yyyy-MM-dd" showMonthDropdown showYearDropdown className="calendar-input" />
          <label>Data wystawienia</label>
          <input type="text" placeholder="Data wystawienia" value={panel.data_wystawienia} onChange={(e) => handleInputChange(index, "data_wystawienia", e.target.value)} />
          <label>Adresy e-mail (oddzielone przecinkami)</label>
          <input type="text" placeholder="example@ex.com, example2@ex.com" value={panel.emails} onChange={(e) => handleInputChange(index, "emails", e.target.value)} />
          <div className="action-buttons">
            <button className="remove-button" onClick={() => removePanel(index)}>−</button>
            <button className="add-button" onClick={addPanel}>+</button>
          </div>
        </div>
      ))}

      <button className="submit-button" onClick={handleSubmit} disabled={loading}>
        {loading ? <div className="loading-circle"></div> : "Wyślij dane"}
      </button>

      <button
        id="resetHiddenButton"
        style={{ display: "none" }}
        onClick={() => resetForm()}
      >
        Hidden Reset
      </button>

      {message.text && <div className={message.type === "success" ? "success-message" : "error-message"}>{message.text}</div>}
    </div>
  );
};

export default AddRecord;
